import React, { useEffect, useState } from "react";
import moment from "moment";
import { Dialog, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import itLoginStatusService from "../../services/itLoginStatus.service";

// Asks an IT Support user, once nobody has taken today yet, whether they are
// responsible for today's IT Support tickets. Same prompt HR gets in Layout.
const ItResponsibilityPrompt = ({ isAuthenticated }) => {
  const [open, setOpen] = useState(false);
  const [assignedName, setAssignedName] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const checkStatus = async () => {
      const role = localStorage.getItem("role");
      const userId = localStorage.getItem("userId");

      if (isAuthenticated && role === "IT SUPPORT" && userId) {
        try {
          const statusResponse = await itLoginStatusService.checkItLoginStatusToday();
          if (!statusResponse?.data?.hasLoginToday) {
            setAssignedName(statusResponse?.data?.assignedName || null);
            setOpen(true);
          }
        } catch (error) {
          console.error("Layout - Error checking IT Support login status:", error);
        }
      }
    };
    checkStatus();
  }, [isAuthenticated]);

  const handleAnswer = async (isResponsible) => {
    if (isResponsible) {
      try {
        setSaving(true);
        await itLoginStatusService.saveItLoginStatus({
          name: localStorage.getItem("name") || localStorage.getItem("userName"),
          time: moment().format("hh:mm A"),
        });
      } catch (error) {
        console.error("Error saving IT Support login status:", error);
      } finally {
        setSaving(false);
      }
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => { }}
      PaperProps={{
        sx: {
          padding: "10px",
          borderRadius: "12px",
          minWidth: "350px",
        },
      }}
    >
      <DialogContent>
        <Typography
          sx={{
            fontFamily: "Open Sans, sans-serif",
            fontSize: "18px",
            fontWeight: 600,
            color: "#1A1C1E",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          Today's Responsibility
        </Typography>
        <Typography
          sx={{
            fontFamily: "Open Sans, sans-serif",
            fontSize: "16px",
            fontWeight: 400,
            color: "#6C7278",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          {assignedName
            ? `Admin has assigned ${assignedName} for today's IT Support tickets. Are you taking the responsibility?`
            : "Are you responsible for today's IT Support tickets?"}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", padding: "20px", gap: "10px" }}>
        <Button
          onClick={() => handleAnswer(false)}
          disabled={saving}
          sx={{
            flex: 1,
            height: "45px",
            borderRadius: "8px",
            border: "1.5px solid #00913E",
            color: "#00913E",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(0, 145, 62, 0.04)",
              border: "1.5px solid #00913E",
            },
          }}
        >
          No
        </Button>
        <Button
          onClick={() => handleAnswer(true)}
          disabled={saving}
          sx={{
            flex: 1,
            height: "45px",
            borderRadius: "8px",
            backgroundColor: "#00913E",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#007a34",
            },
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItResponsibilityPrompt;
